import { impersonate as impersonateUser } from './User/sources/user';

export interface EventImpersonateConfig {
  ({ userChanged }: { userChanged?: boolean }): void;
}

class Impersonate {
  impersonate = async (userId: number | string, reconnect?: boolean) => {
    const { token } = await impersonateUser({ userId });

    sessionStorage.setItem('impersonate', JSON.stringify({ token, userId }));

    this.listeners.map((listener: EventImpersonateConfig) =>
      listener({
        userChanged: !reconnect,
      })
    );

    return token;
  };

  getImpersonateToken = async () => {
    const storageImpersonate = sessionStorage.getItem('impersonate');

    if (!storageImpersonate) {
      return;
    }

    const { token, userId } = JSON.parse(storageImpersonate);

    if (!this.checkTokenExpirationDate(token)) {
      this.dismissImpersonate(true);
      return await this.impersonate(userId, true);
    }

    return token;
  };

  checkTokenExpirationDate(token: string) {
    const { exp } = JSON.parse(atob(token.split('.')[1]));
    const remainingSeconds = exp - Date.now() / 1000;
    return remainingSeconds > 0;
  }

  dismissImpersonate(reconnect?: boolean) {
    sessionStorage.removeItem('impersonate');

    this.listeners.map((listener: EventImpersonateConfig) =>
      listener({
        userChanged: !reconnect,
      })
    );
  }

  listeners: EventImpersonateConfig[] = [];

  subscribe(handler: EventImpersonateConfig) {
    this.listeners = [...this.listeners, handler];
  }

  unsubscribe(handler: EventImpersonateConfig) {
    this.listeners = this.listeners.filter(
      (listener: EventImpersonateConfig) => listener !== handler
    );
  }
}

export const impersonateAuth = new Impersonate();
